import {lazy} from '@aboutyou/lazy-imports';

export const DeepLinkLoaderPage = lazy(() =>
  import('./DeepLinkLoaderPage.eager').then(mod => ({
    default: mod.DeepLinkLoaderPage,
  })),
);
